<!-- FocalPathLanding.svelte -->

<script>
  import { onMount } from "svelte";
  // import Graph from "../FocalPath/Graph.svelte"; -> Obsoleto
  import RadarChart from "../FocalPath/RadarChart.svelte";
  import { push } from 'svelte-spa-router';

  let animate = $state(false);
  let showForkMan = $state(false);
  let showAppNameText = $state(false);
  let showCTAbutton = $state(false);

  // Comic images visibility state
  let comicImagesVisible = $state([false, false, false, false, false]);
  let comicImageRefs = [];

  function startAnimations() {
    animateLambdaIcon();
    setTimeout(animateForkMan, 1000);
    setTimeout(showAppName, 2000);
    setTimeout(showCTA, 3000);
  }

  function animateLambdaIcon() {
    animate = true;
  }

  function animateForkMan() {
    showForkMan = true;
  }

  function showAppName() {
    showAppNameText = true;
  }

  function showCTA() {
    showCTAbutton = true;
  }

  // Intersection Observer for comic images
  function setupComicObserver() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = parseInt(entry.target.dataset.index);
            comicImagesVisible[index] = true;
          }
        });
      },
      {
        threshold: 0.3, // Trigger when 30% of the image is visible
        rootMargin: '0px 0px -100px 0px' // Start animation slightly before the image comes into view
      }
    );

    comicImageRefs.forEach((ref, index) => {
      if (ref) {
        ref.dataset.index = index;
        observer.observe(ref);
      }
    });

    return observer;
  }

  // Start the sequence of animations
  onMount(() => {
    const id = setTimeout(startAnimations, 1500); // wait 1.5 s *after* mount
    
    // Setup comic images observer
    const comicObserver = setupComicObserver();
    
    return () => {
      clearTimeout(id); // cleanup on hot-reload
      comicObserver.disconnect();
    };
  });

  // Function for making the buttons navigate to the other webpage
  function goToPath() {
    push('/DeciderApp');
  }
</script>

<main>
  <div class="landing-content">
    <!-- <p>prueba</p> -->
    <div class="images-external-wrapper">
      <div class="forkman-wrapper">
        <img src="Fork man.svg" alt="Fork man" class:fadeIn={showForkMan} />
      </div>
      <div class="lambda-wrapper">
        <img
          src="/Icons/Lambda icon.svg"
          alt="Lambda Icon"
          class:spin={animate}
        />
      </div>
    </div>
    <div class="appName-wrapper">
      <img
        src="Nombre tipográfico.svg"
        alt="appName"
        class:fadeIn={showAppNameText}
      />
    </div>
    <p class="app-subtitle" class:fadeIn={showAppNameText}>
      Time is limited<br /> Choose right
    </p>

    <button class="cta-button" class:fadeIn={showCTAbutton} onclick={goToPath}
      >Become Decisive</button
    >
    <p class="cta-subtext" class:fadeIn={showCTAbutton}>No signup. See how it works in seconds</p>
  </div>

  <div
    style="width: 100%; padding: 2em; background-color: #1E1E1E; color: white;"
  >
    <p style="margin-top:1.5em;">What if you had taken that job?</p>
    <p style="margin-top:1.5em;">
      What if you had commited to that promising side project?
    </p>
    <p style="margin-top:1.5em;">What if you had chosen another city?</p>
    <p style="margin-top:3em;">What if...</p>
  </div>

  <div class="section image-text">
    <div class="container">
      <div class="columns is-vcentered">
        <div class="column is-8">
          <!-- Column for Image -->
          <RadarChart
            categories={[
              {name: "Trascendence", type: "Critical"},
              {name: "Impact on relationships", type: "Critical"},
              {name: "Cost", type: "Critical"},
              {name: "Long term benefit", type: "Critical"},
              {name: "Risk", type: "Critical"}
            ]}
            paths={[
              { name: "", values: [1, 5, 3, 3, 4], color: "#CBBAED" },
              { name: "", values: [5, 3, 4, 1.5, 3], color: "#BF1363" },
            ]}
          />
        </div>
        <div class="column is-4">
          <!-- Column for Text -->
          <p>
            <strong>Focal Path</strong> is a <strong>decision engine</strong>, helping you
            <strong>structure</strong>
            your thinking when facing <strong>high stakes choices</strong> 
            so you <strong>choose faster</strong> and choose <strong>once</strong>.
          </p>
        </div>
      </div>
    </div>
  </div>

  <!--Cómic -->
  <div
    class="section comic-section"
    style=" background-color: #1E1E1E; color: white; max-width: 100%;"
  >
    <div class="container">
      <div class="comic-images-wrapper">
        <div class="comic-image-container" bind:this={comicImageRefs[0]}>
          <img src="/Comic/Comic Img 1.svg" alt="Comic 1" class="comic-img" class:visible={comicImagesVisible[0]} />
        </div>
        <div class="comic-image-container" bind:this={comicImageRefs[1]}>
          <img src="/Comic/Comic Img 2.svg" alt="Comic 2" class="comic-img" class:visible={comicImagesVisible[1]} />
        </div>
        <div class="comic-image-container" bind:this={comicImageRefs[2]}>
          <img src="/Comic/Comic Img 3.svg" alt="Comic 3" class="comic-img" class:visible={comicImagesVisible[2]} />
        </div>
        <div class="comic-image-container" bind:this={comicImageRefs[3]}>
          <img src="/Comic/Comic Img 4.svg" alt="Comic 4" class="comic-img" class:visible={comicImagesVisible[3]} />
        </div>
        <div class="comic-image-container" bind:this={comicImageRefs[4]}>
          <img src="/Comic/Comic Img 5.svg" alt="Comic 5" class="comic-img" class:visible={comicImagesVisible[4]} />
        </div>
      </div>
    </div>
  </div>

  <div class="section image-text">
    <div class="container">
      <h1 style="font-size: 200%; margin-bottom: 50px;">How it works</h1>

      <img
        src="How it works.png"
        alt="How it works"
        style="width: 90vw; max-width: 500px;"
      />
    </div>
  </div>

  <!-- Adding SVG Image -->

  <section>
    {#if showAppNameText} <!-- Pruebo a meter este if para ver si soluciona el error de 'e is undefined'-->
    <div style="margin-top: 5em;">
      <img
        src="Nombre tipográfico.svg"
        alt="appName"
        class:fadeIn={showAppNameText}
      />
    </div>
    {/if}
    <p style="margin: 60px">
      <em
        >Become who you want to be<br />
        One decision at a time
      </em>
      <!-- <em
          >Take advantage of the most advanced device in the world... <br /> The
          human Neocortex
        </em> -->
    </p>
    <section class="svg-image-section" style="padding: 2em; margin-bottom:3em">
      <div class="container has-text-centered">
        <img
          src="Focal path expanded.svg"
          alt="Focal Path Expanded"
          class="focal-path-expanded-img"
        />
      </div>
    </section>

    <!-- <h1 style="font-size: 200%"> Systems <br> produce <br> results</h1> -->
    <!-- <div style="margin-top: 2em;">
        <h1 style="font-size: 200%; padding: 0.5em">Systems</h1>
        <h1 style="font-size: 200%; padding: 0.5em">Produce</h1>
        <h1 style="font-size: 200%; padding: 0.5em">Results</h1>
      </div> -->

    <!-- <button style="margin:5em;" on:click={goToPath}
        ><span class="icon-lambda">
          <img
            src="./Icons/Lambda icon thick.svg"
            alt="Lambda"
            style="height: 3em;"
          />
        </span></button> -->

    <button class="second-cta-button" style="margin: 1em;" onclick={goToPath}>Find Your Best Path</button>
    <p class="second-cta-subtext">Visualize your decision, compress time to clarity.</p>
  </section>

  <!-- Examples, capabilities, limitations -->
  <section class="section">
    <div class="container">
      <div class="columns">
        <!-- First Column - Examples -->
        <div class="column">
          <div class="has-text-centered">
            <!-- Custom Icon -->
            <img
              src="/Icons/Examples Icon 2.svg"
              alt="Examples Icon"
              class="icon is-large"
            />
            <!-- Title -->
            <h4 class="title is-4" style="padding: 20px;">Examples</h4>
          </div>
          <!-- Text Cards -->
          <div class="box">
            <b>Should I quit my job</b><br />
            to pursue a more fulfilling career?
          </div>
          <div class="box">
            <b>Should I start investing in crypto?</b><br /> or keep saving for a
            house
          </div>
          <div class="box">
            <b>Help me prioritize projects</b><br /> to discard distractions and
            get real traction
          </div>
        </div>

        <!-- Second Column - Capabilities -->
        <div class="column">
          <div class="has-text-centered">
            <!-- Custom Icon -->
            <img
              src="/Icons/Capabilities Icon.svg"
              alt="Capabilities Icon"
              class="icon is-large"
            />
            <!-- Title -->
            <h4 class="title is-4" style="padding: 20px;">Capabilities</h4>
          </div>
          <!-- Text Cards -->
          <div class="box">
            <b>Prevent biases</b><br /> from misleading you and separate skill from
            chance
          </div>
          <div class="box">
            <b>Learn to observe your emotions</b><br /> and expand your perspective
          </div>
          <div class="box">
            <b>Have peace of mind</b><br /> you made the best choice with the information
            you had
          </div>
        </div>

        <!-- Third Column - Limitations -->
        <div class="column">
          <div class="has-text-centered">
            <!-- Custom Icon -->
            <img
              src="/Icons/Limitations icon.svg"
              alt="Limitations Icon"
              class="icon is-large"
            />
            <!-- Title -->
            <h4 class="title is-4" style="padding: 20px;">Limitations</h4>
          </div>
          <!-- Text Cards -->
          <div class="box">
            <b>Will not decide for you</b> and will require some reflection
          </div>
          <div class="box">
            You will still need a <b>clear goal</b> to make a good decision
          </div>
          <div class="box">
            You will still need <b>good information</b> to make a good decision
          </div>
        </div>
      </div>
      <!-- End columns -->

      <!-- <div>
          <img
            src="./Icons/Brain icon.png"
            alt="Brain Icon"
            style="width: 100px; height: auto;"
          />
        </div> -->
    </div>
    <!-- End container -->
  </section>

  <!--  Footer -->
  <footer class="footer" style="margin-top: 2em;">
    <div
      class="content has-text-centered"
      style="margin-left: 2em; margin-right: 2em"
    >
      <!-- Quotes -->

      <!-- <div class="columns">
          <div class="column">
            <blockquote>
              <em
                >The successful warrior is the average man with laser-like focus
                <p style="text-align: right; margin-top: 1em;">Bruce Lee</p></em
              >
            </blockquote>
          </div>
          <div class="column">
            <blockquote>
              <em
                >Learn to observe your emotions and use them to think, not think
                with your emotions <p style="text-align: right; margin-top: 1em;">
                  Robert T. Kiyosaki
                </p></em
              >
            </blockquote>
          </div>
        </div>
        <blockquote>
          <em
            >What makes a decision great is not that it has a great outcome. A
            great decision is the result of a good process, and that process must
            include an attempt to accurately represent our own state of knowledge
            <p style="text-align: right; margin-top: 1em;">
              Thinking in bets, Annie Duke
            </p></em
          >
  
        </blockquote> -->
      <!-- <blockquote><em>Action expresses priorities<p style = "text-align: right; margin-top: 1em;">Mahatma Ghandi</p></em></blockquote> -->

      <p>
        <strong>Focal Path</strong> by
        <a href="https://forms.gle/PD7tAohbUq83FK4k9">Antonio Martin</a>. The
        source code is licensed
        <a href="http://opensource.org/licenses/mit-license.php">MIT</a>. The
        website content is licensed
        <a href="http://creativecommons.org/licenses/by-nc-sa/4.0/"
          >CC BY NC SA 4.0</a
        >.
      </p>
      <hr />
      <div class="references" style="font-size: small;">
        <p style="padding: 1em;">
          Focal Path is based on Prospect Theory, Behavioral Economics, and
          Cognitive Psychology research
        </p>
        <!-- Bibliography -->
        <ul>
          <li>
            <p>
              C.Heath, <cite
                >Decisive: How to Make Better Choices in Life and Work</cite
              >, 1st edition, (2013)
            </p>
          </li>
          <li>
            <p>
              E.J. Johnson, <cite
                >The Elements of Choice: Why the Way We Decide Matters</cite
              >, 1st edition, (2021)
            </p>
          </li>
          <li>
            <p>
              D. Kahneman, <cite>Thinking fast and slow</cite>, 1st edition,
              (2011)
            </p>
          </li>
          <li>
            <p>
              R.H. Thaler, <cite
                >Prospect Theory: An Analysis of Decision under Risk</cite
              >, Econometrica. 47 (2): 263-291. doi:10.2307/1914185 (1979)
            </p>
          </li>
          <li>
            <p>
              R.H. Thaler, <cite
                >Misbehaving: The Making of Behavioral Economics</cite
              >, 1st edition, (2016)
            </p>
          </li>
          <li>
            <p>
              R. Dobelli, <cite>The art of thinking clearly</cite>, 1st edition,
              (2011)
            </p>
          </li>
          <li>
            <p>
              A. Duke, <cite
                >Thinking in Bets: Making Smarter Decisions When You Don't Have
                All the Facts</cite
              >, 1st edition, (2018)
            </p>
          </li>
          <li>
            <p>
              J.S. Hammond, R.L. Keeney, H. Raiffa, <cite
                >Smart Choices: A Practical Guide to Making Better Decisions</cite
              >, 1st edition, (1998)
            </p>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</main>

<style>
  .references ul li {
    margin-bottom: 1em; /* Adjust the value as needed */
  }

  /* Comic Section Styles */
  .comic-section {
    padding: 4em 0;
    width: 100vw;
    margin-left: calc(-50vw + 50%);
  }

  .comic-images-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8.5em;
    max-width: 700px;
    margin: 0 auto;
    padding: 0 2em;
  }

  .comic-image-container {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .comic-img {
    width: 75%;
    max-width: 450px;
    height: auto;
    opacity: 0;
    transform: translateY(50px);
    transition: opacity 0.8s ease-out, transform 0.8s ease-out;
  }

  .comic-img.visible {
    opacity: 1;
    transform: translateY(0);
  }

  /* Mobile responsiveness for comic section */
  @media (max-width: 768px) {
    .comic-section {
      padding: 3em 0;
    }
    
    .comic-images-wrapper {
      gap: 3em;
      padding: 0 1em;
    }
    
    .comic-img {
      width: 85%;
      max-width: 350px;
    }
  }

  @media (max-width: 480px) {
    .comic-images-wrapper {
      gap: 7em;
      padding: 0 0.5em;
    }
    
    .comic-img {
      width: 95%;
      max-width: 300px;
    }
  }

  main {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    text-align: center;
    /* Removed 'justify-content: center' and 'height: 100vh' */
  }

  .section img {
    border-radius: 5px; /* Rounded corners for images */
    /* Other styles as needed */
  }

  button {
    background-color: #9cfffa; /* A bright color for visibility */
    color: #084b83; /* Contrast text color */
    border: none; /* Remove default border */
    padding: 10px 20px; /* Adequate padding for clickability */
    border-radius: 12px; /* Slightly rounded corners */
    font-size: 1em; /* Matching font size */
    cursor: pointer; /* Cursor indication for clickability */
    transition: background-color 0.3s ease; /* Smooth transition for hover effect */
  }

  .cta-button {
    position: absolute;
    bottom: 5em;
    opacity: 0;
  }

  .cta-subtext {
    position: absolute;
    bottom: 2.5em;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    font-size: 0.95em;
    color: gray;
    max-width: 90vw;
    text-align: center;
    line-height: 1.3;
  }

  .second-cta-button {
    font-size: 1.2em; /* 20% larger than base 1em */
    padding: 12px 24px; /* 20% larger than base 10px 20px */
  }

  .second-cta-subtext {
    font-size: 0.95em;
    color: gray;
    text-align: center;
    margin: 0.5em auto 2em auto;
    max-width: 90vw;
    line-height: 1.3;
  }

  .focal-path-expanded-img {
    max-width: 800px; /* Maximum width for desktop */
    width: 100%;
    height: auto;
  }

  button:hover,
  button:focus {
    background-color: #ffec6c; /* Slightly darker color on hover/focus for feedback */
  }

  .image-text {
    margin-top: 0em;
  }

  .image-text .column {
    display: flex;
    /*justify-content: center;  Centers vertically */
    flex-direction: column; /* Stacks items vertically */
    text-align: left;
    min-height: 100%; /* Ensure the column takes full height */
  }

  .image-text img {
    /* max-width: 100%; Ensures the image is responsive and fits the column */
    height: auto; /* Maintains the aspect ratio of the image */
  }

  .landing-content {
    position: relative; /* Ensures that absolute positioning is relative to this container */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    max-width: 100%;
  }

  /* Style for the text column */
  .column {
    padding: 40px; /* Add some padding */
  }

  .images-external-wrapper {
    display: flex;
  }

  img[alt="Lambda Icon"] {
    width: 95px; /* Adjust based on your design */
  }

  .spin {
    animation: spinAndFlatten 0.5s forwards;
  }

  @keyframes spinAndFlatten {
    from {
      transform: rotate(0deg) scale(1, 1);
    }
    to {
      /* transform: rotate(-248deg) scale(0.5, 1.2); */
      transform: rotate(248deg) scale(0.5, 1.15); /* Invierto la rotación al cambiar de lado la ilustración*/
    }
  }

  /* Fork Man Image */
  img[alt="Fork man"] {
    opacity: 0;
    height: 110px;
    width: 100px;
  }

  img[alt="appName"] {
    opacity: 0;
    height: 65px;
    width: auto;
    min-width: 300px;
    max-width: 90vw;
  }

  /* Fade In Animation */
  .fadeIn {
    animation: fadeIn 0.5s forwards;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  /* Adjust positions to bring images closer */
  /* .lambda-wrapper { */
  /*  margin-right: -55px;  /* Adjust the value to bring closer */
  /* } */

  /* .forkman-wrapper { */
  /* margin-top: -30px; /* Adjust the value to bring closer */
  /* } */

  /* Application Name */
  .appName-wrapper {
    margin: 10em;
    margin-top: 5em;
    left: 50vw;
  }

  /* Application Subtitle */
  .app-subtitle {
    position: absolute;
    margin-top: 15em; /* Adjust to position below the app name */
    font-size: 1.2em; /* Smaller and more subtle than the app name */
    color: gray; /* More subtle color */
    opacity: 0; /* Initially hidden */
  }

  :global(body) {
    /* font-family: 'Roboto', sans-serif; */
    font-family: "IBM Plex Mono", monospace; /* Creo que esto ya no hace falta porque está en global en app.svelte*/
  }
</style>
